import { BASE_ADMIN_API, fetchAPI } from '@/services/api';

/** One HSIC recommendation from admin POST /hsic/recommendations. */
export interface HsicIndustryRecommendVO {
    code: string;
    nameZh: string;
    nameEn: string;
    reason: string;
}

/** Request body for HSIC AI recommendation. */
export interface HsicIndustryRecommendBO {
    description: string;
}

/** Dictionary row from admin POST /hsic/list. */
export interface HsicIndustryVO {
    id?: string;
    code: string;
    level?: number;
    parentCode?: string | null;
    nameZh: string;
    nameEn?: string;
}

/** Query body for POST /hsic/list. */
export interface HsicIndustryQueryBO {
    code?: string;
    level?: number;
    parentCode?: string;
    nameZh?: string;
    nameEn?: string;
}

const base = `${BASE_ADMIN_API}/hsic`;

/**
 * Rank up to five level-5 HSIC codes for a free-text business description.
 */
export async function recommendHsicIndustries(description: string) {
    return fetchAPI<HsicIndustryRecommendVO[]>(`${base}/recommendations`, {
        method: 'POST',
        body: JSON.stringify({ description } satisfies HsicIndustryRecommendBO),
    });
}

/**
 * List HSIC dictionary rows (e.g. level=5 six-digit codes) without AI.
 */
export async function listHsicIndustries(query: HsicIndustryQueryBO) {
    return fetchAPI<HsicIndustryVO[]>(`${base}/list`, {
        method: 'POST',
        body: JSON.stringify(query),
    });
}

export const HsicIndustryService = {
    recommendHsicIndustries,
    listHsicIndustries,
};
